import React, { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'


const SurveyPage  = () => {
  const [searchParams] = useSearchParams()
  const [message, setMessage] = useState('')

  useEffect(() => {
    const timer = setTimeout(() => {
      try {
        const uid = searchParams.get('uid')
        console.log("object", uid)
        if (uid) {
          window.location.href = `https://spapi.pollsphere.com/api/v1/surveys/callback?status=COMPLETED&uid=${uid}`
        } else {
          setMessage('UID not found in URL')
        }
      } catch (error) {
        console.error('Error:', error)
        setMessage('Error navigating')
      }
    }, 10000) // 10 seconds

    return () => clearTimeout(timer)
  }, [searchParams])

  return (
    <div>
      <p>this is a survey page</p>
      {message && <p style={{ marginTop: '20px', color: 'green', fontWeight: 'bold' }}>{message}</p>}
    </div>
  )
}

export default SurveyPage
